/** Activity-log entry type as returned on the wire (`type_id`). */
export enum ActivityLogActivities {
	Gems = 1,
	Diamonds = 2,
	Points = 3,
	LevelChanged = 4,
	Bonus = 5,
	PrizeDrop = 6,
	Minigame = 7,
	RaffleTicket = 8,
	Avatar = 9,
	Task = 10,
	Mission = 11,
	Badge = 12,
	TangiblePrize = 13,
	Jackpot = 14,
	Spin = 15,
	NoPrize = 16,
	Leaderboard = 17,
	Tournament = 18,
	ClanTournament = 19,
	Clan = 20,
}
